module.exports = __webpack_public_path__ + "static/media/movImage-main.c19d0761.png";